import { render } from "./Dashboard.vue?vue&type=template&id=bd170e9a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd170e9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd170e9a', __exports__)) {
    api.reload('bd170e9a', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=bd170e9a", () => {
    api.rerender('bd170e9a', render)
  })

}


export default __exports__